// extracted by mini-css-extract-plugin
module.exports = {"root":"PortfolioStatistics__root___1WR_t","large":"PortfolioStatistics__large___14p3p","small":"PortfolioStatistics__small___2hjyA"};